<template>
    <div class="text-xs flex items-center space-x-1 justify-center font-robotomono">
        <span v-if="withDate">
            {{currentDate}}
        </span>
        <span class="flex justify-center items-center">
            {{ clock }}
        </span>
    </div>
</template>

<script setup>
import { computed, reactive, ref } from 'vue';

const props = defineProps({
    time:{
        type: String,
        default: new Date().toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false}),
    },
    cycle:{
        type: String,
        default: 'increment'
    },
    format:{
        type: String,
        default: 'HH:mm:ss'
    },
    withDate:{
        type: Boolean,
        default: false
    }
})

const currentTime = ref()
const currentDate = ref()
const tictac = ref()

const clock = computed(() => {
    if(!currentTime.value){
        currentTime.value = timeToSeconds(props.time)
    }
    tictac.value = setTimeout(() => {currentTime.value = currentTime.value + 1}, 1000)
    return setClock(currentTime.value)
})

function timeToSeconds(time){
    const [hours, minutes, seconds] = time.split(':');

    return Number(hours) * 60 * 60 + Number(minutes) * 60 + Number(seconds)
}

function setClock(seconds){
    if(props.withDate){
        currentDate.value = new Date().toLocaleDateString('pt-BR')
        const time = new Date(seconds * 1000).toISOString().slice(11,19)
        return time
    }
    return new Date(seconds * 1000).toISOString().slice(11,19)
}



</script>

<style>

</style>
